"use strict";'use strict';

var chunk2BC5TKBD_js = require('./chunk-2BC5TKBD.js');
require('./chunk-3WEXFDNL.js');



module.exports = chunk2BC5TKBD_js.Included_default;
